import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {createSelector} from "reselect";
import { globalService as gs } from '../../../common/services';
import { defaultActions } from '../../../common/redux/actions';
import { Role } from '../../../helpers';

class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loggedIn: props.authentication.loggedIn,
            authentication: props.authentication,
        }
    }

    componentDidMount() {
        const { dispatch, pages } = this.props;
		pages && pages.data.length === 0 && dispatch(defaultActions.pages("GET", {moduleId: 'page'}));
    }

    getYear() {
        const d = new Date();
        return d.getFullYear();
    }

    render() {
        const { loggedIn } = this.state;
        const { pages, authentication } = this.props;
        const pagesArray = pages.data ? pages.data : [];
        //console.log('pages', pagesArray);
        const user = authentication && authentication.authentication && authentication.authentication.user;
        return (
            <footer id="footer" className="w-100 float-left">
                <div className="container">
                    <div className="col-md-10 mx-auto">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-6">
                                <h5>About</h5>
                                <ul className="footer-menu list-inline flex-wrap">
                                    <li><NavLink to="/about-us">Who we are?</NavLink></li>
                                    {pagesArray && pagesArray.map(page => 
                                        page.slug != 'tutor' ? <li key={page.id}><NavLink to={`/${page.slug}`}>{page.title}</NavLink></li> : ''
                                    )}
                                    
                                    {/* {pagesArray && pagesArray.map(page => 
                                        <li key={page.id}><NavLink className="text-white" to={`/${page.slug}`}>{page.title}</NavLink></li>
                                    )} */}
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-6 col-6">
                                <h5>Join the adventure</h5>
                                <ul className="footer-menu list-inline flex-wrap">
                                    <li className={`${(user && user.role === Role.Tutor) ? 'd-none' : '' }`}><NavLink to="/search-tutors">All subjects</NavLink></li>
                                    {!loggedIn && <li><NavLink to="/tutor">Become a Tutor</NavLink></li>}
                                    {/* {pagesArray && pagesArray.map(page => 
                                        <li key={page.id}><NavLink className="text-white" to={`/${page.slug}`}>{page.title}</NavLink></li>
                                    )} */}
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-6 col-6">
                                <h5>Help</h5>
                                <ul className="footer-menu list-inline flex-wrap">
                                    {/* <li><NavLink to="/term-condition">Terms & Conditions</NavLink></li>
                                    <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                                    <li><NavLink to="/faq"> FAQs</NavLink></li> */}                                   
                                    <li><NavLink to="/faqs"> FAQs</NavLink></li>
                                    <li><NavLink to="/contact-us">Contact</NavLink></li>
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-6 col-6">
                                <ul className="navbar-nav navbar-social">
                                    <li className="nav-item">
                                        <a className="nav-link" rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/K12TutorConnectLLC"><i className="fab fa-facebook-f"></i>Facebook</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/k12tutorconnect/"><i className="fab fa-instagram"></i>Instagram</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" rel="noopener noreferrer" target="_blank" href="https://twitter.com/k12tutorconnect"><i className="fab fa-twitter"></i>Twitter</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" rel="noopener noreferrer" target="_blank" href="https://www.tiktok.com/@k12tutorconnect?is_from_webapp=1&sender_device=pc"><i className="fab fa-tiktok"></i>TikTok</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/company/k12-tutor-connect/"><i className="fab fa-linkedin-in"></i>Linkedin</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-5 col-md-12 text-sm-center text-lg-left">    
                                <div className="copyright mb-3">
                                    <NavLink to="/">{gs.siteTitle()}</NavLink> Connect <small style={{fontSize: "60%"}}>TM</small>, sharing knowledge <i className="fas fa-heart"></i>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-12 text-sm-center text-lg-left">    
                                <div className="f-logo">
                                    <img src="/images/svg/Logo-footer.svg" />
                                    <a rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.k12.app" target="_blank">
                                        <img src="/images/android-app.png" className="ml-3" />
                                    </a>
                                    <a rel="noopener noreferrer" href="https://apps.apple.com/us/app/k12-connect/id1548124906" target="_blank">
                                        <img src="/images/apple-app.png" className="ml-2" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>
        );
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const pagesSelector = createSelector(
    state => state.pages,
    pages => pages
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    pagesSelector,
    (process, authentication, pages) => ({
        process, authentication, pages
    })
);

export default connect(mapStateToProps)(Footer);
